import React, { ReactNode, useMemo, useState } from "react";
import { IUiState } from "./uiTypes";

const UiContextState = React.createContext<IUiState>({} as IUiState);

const UiProvider = ({ children }: { children: ReactNode }) => {
    const [activeCaptionTrack, setActiveCaptionTrack] = useState<string | undefined>();
    const [searchQuery, setSearchQuery] = useState<string>("");
    const [searchMatchIndex, setSearchMatchIndex] = useState<number>(0);

    const state = useMemo(() => {
        return { activeCaptionTrack, setActiveCaptionTrack, searchQuery, setSearchQuery, searchMatchIndex, setSearchMatchIndex };
    }, [activeCaptionTrack, setActiveCaptionTrack, searchQuery, setSearchQuery, searchMatchIndex, setSearchMatchIndex]);
    return <UiContextState.Provider value={state}>{children}</UiContextState.Provider>;
};

export { UiContextState, UiProvider };
